import styled from "styled-components";

export const MusicHallRegisEquipmentProviderStyled = styled.div`
  .equipment_layout {
    margin-bottom: 27px;
    .equipment_text1 {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .equipment_text2 {
      margin-bottom: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_2};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    }
    .checkbox_layout {
      margin-right: 12px;
      padding: 0 20px;
    }
  }
  .button_layout {
    padding: 0px 42px;
    display: flex;
    justify-content: center;
    column-gap: 36px;
    .button1 {
      flex: 1;
    }
    .button2 {
      flex: 1;
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .equipment_layout {
      .checkbox_layout {
        padding: 0 12px;
      }
    }
    .button_layout {
      padding: 0;
      display: flex;
      column-gap: 16px;
    }
  }
`;
